(() => {
  const SCROLL_TRIGGER = 420;
  const buttons = document.querySelectorAll('.js-back-to-top');

  if (!buttons.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let ticking = false;

  const setVisibility = () => {
    const showButton = window.scrollY > SCROLL_TRIGGER;

    buttons.forEach((button) => {
      button.classList.toggle('is-visible', showButton);
      button.setAttribute('aria-hidden', String(!showButton));
    });
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      setVisibility();
      ticking = false;
    });
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  setVisibility();
})();
